module.exports = __webpack_public_path__ + "img/cash_nl100.d1a2fbfd.png";